import {
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import Box from 'src/components/Box/Box'
import CsvInputField, {
  CsvInputFieldTemplateOption,
} from 'src/components/CsvInputField/CsvInputField'
import { FormProps } from 'src/types'
import { css } from 'styled-components'

interface CsvInputBoxProps {
  id?: string
  className?: string
  csvProps: FormProps<File>
  title: React.ReactNode
  subtitle: React.ReactNode
  note?: React.ReactElement
  templateDownloadOptions: Array<CsvInputFieldTemplateOption<string>>
  loadingTemplate: boolean
}

const CsvInputBox: React.FC<CsvInputBoxProps> = (props): React.ReactElement => {
  return (
    <Box
      id={props?.id}
      css={css`
        display: flex;
        flex-direction: column;
      `}
    >
      <span
        css={css`
          ${getFontCss(
            16,
            themeConstants.colors.font_primary,
            styleConstants.fontFamilies.medium,
          )};
        `}
      >
        {props.title}
      </span>
      <span
        css={css`
          margin-top: 8px;
          ${getFontCss(
            16,
            themeConstants.colors.font_primary,
            styleConstants.fontFamilies.regular,
          )};
        `}
      >
        {props.subtitle}
      </span>
      <CsvInputField
        css={css`
          margin-top: 30px;
        `}
        value={props.csvProps.value}
        onDrop={(files: File[]): void => {
          props.csvProps.onChange(files[0])
        }}
        errors={props.csvProps.errors}
        loadingBulkTemplate={props.loadingTemplate}
        templateOptions={props.templateDownloadOptions}
      />
      {props.note && (
        <p
          css={css`
            margin-top: 10px;
            padding: 0px 0px;
            ${getFontCss(
              12,
              themeConstants.colors.font_primary,
              styleConstants.fontFamilies.medium,
            )};
          `}
        >
          {props.note}
        </p>
      )}
    </Box>
  )
}

export default React.memo(CsvInputBox)
